import React from 'react';
import { Link } from 'react-router-dom';
import env from '../../environment.js';

const LinkDownloadExcel = ({ handleExport }) => {
    const styles = {
        color: '#789D16',
    };

    return (
        <Link
            to="#"
            onClick={e => {
                e.preventDefault();
                handleExport();
            }}
            className="m-r-2"
            style={styles}>
            <img src={env.images.icon.xls} className="pr-1" />
            <span className="clickable">Descargar Excel</span>
        </Link>
    );
};

export default LinkDownloadExcel;
